import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
// import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxDefaultAction } from './view_sections/view_actions/lightbox_default_action';
import { LightboxActiveFilters } from './lightbox_overview/lightbox_active_filters';
import { LightboxVehicleActiveFilters } from './lightbox_overview/lightbox_vehicle_active_filters';
import { isChangedFilters } from '../../../../../utilities/match_catalog_filters';

function LightboxOverview(props) {
    const isRegoLookupOrVehicleConfigurator = ['rego_lookup', 'vehicle_configurator'].indexOf(props.lastUsedConfigurator) >= 0;

    return (
        <LightboxView
            opened={props.opened}
        >
            {/* <TranslationContainer translationKey="catalog-filters-headline-default" targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer> */}

            <LightboxViewContent isDefault={true}>
                {!isRegoLookupOrVehicleConfigurator &&
                    <LightboxActiveFilters
                        productType={props.productType}
                        filterValues={props.filterValues}
                        filterOptions={props.filterOptions}
                        onUnsetFilter={props.onUnsetFilter}
                        displayDimensions={props.displayDimensions}
                    />
                }
                {isRegoLookupOrVehicleConfigurator &&
                    <LightboxVehicleActiveFilters
                        filterValues={props.filterValues}
                        filterOptions={props.filterOptions}
                        onUnsetFilter={props.onUnsetFilter}
                        productType={props.productType}
                    />
                }
                {props.children}
            </LightboxViewContent>

            <LightboxDefaultAction
                onApplyClick={props.onApplyClick}
                onResetAndCloseClick={props.onResetAndCloseClick}
                isDisabled={isChangedFilters(props.filterValues)}
                productType={props.productType}
            />
        </LightboxView>
    );
}

LightboxOverview.propTypes = {
    openView: PropTypes.func.isRequired,
    onApplyClick: PropTypes.func.isRequired,
    onResetAndCloseClick: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
    filterValues: PropTypes.object.isRequired,
    filterOptions: PropTypes.object.isRequired,
    onUnsetFilter: PropTypes.func.isRequired,
    productType: PropTypes.string.isRequired,
    lastUsedConfigurator: PropTypes.string,
    displayDimensions: PropTypes.string,
};

LightboxOverview.defaultProps = {
    lastUsedConfigurator: '',
};

export { LightboxOverview };
